import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function base({ size = 20, ...rest }: IconProps) {
  return { width: size, height: size, ...rest };
}

export function HomeIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...base(props)}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m20.479 7.57827-5.386-4.45325c-1.8143-1.50003-4.3717-1.50003-6.18597 0l-5.38606 4.45325c-.97038.80232-1.52097 2.01878-1.52097 3.28803v6.9446c0 2.2551 1.73415 4.1891 4 4.1891h2c1.10457 0 2-.8954 2-2v-3.2522c0-1.2675.9521-2.1891 2-2.1891s2 .9216 2 2.1891v3.2522c0 1.1046.8954 2 2 2h2c2.2659 0 4-1.934 4-4.1891v-6.9446c0-1.26924-.5506-2.48571-1.521-3.28803z"
      />
    </svg>
  );
}

export function HeartIcon(props: IconProps) {
  return (
    <svg viewBox="0 -28 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...base(props)}>
      <path d="m471.382812 44.578125c-26.503906-28.746094-62.871093-44.578125-102.410156-44.578125-29.554687 0-56.621094 9.34375-80.449218 27.769531-12.023438 9.300781-22.917969 20.679688-32.523438 33.960938-9.601562-13.277344-20.5-24.660157-32.527344-33.960938-23.824218-18.425781-50.890625-27.769531-80.445312-27.769531-39.539063 0-75.910156 15.832031-102.414063 44.578125-26.1875 28.410156-40.613281 67.222656-40.613281 109.292969 0 43.300781 16.136719 82.9375 50.78125 124.742187 30.992188 37.394531 75.535156 75.355469 127.117188 119.3125 17.613281 15.011719 37.578124 32.027344 58.308593 50.152344 5.476563 4.796875 12.503907 7.4375 19.792969 7.4375 7.285156 0 14.316406-2.640625 19.785156-7.429687 20.730469-18.128907 40.707032-35.152344 58.328125-50.171876 51.574219-43.949218 96.117188-81.90625 127.109375-119.304687 34.644532-41.800781 50.777344-81.4375 50.777344-124.742187 0-42.066407-14.425781-80.878907-40.617188-109.289063z" />
    </svg>
  );
}

export function PlateIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...base(props)}>
      <path d="M12,0C5.373,0,0,5.373,0,12c0,5.223,3.342,9.654,8,11.303V15h-.5c-1.378,0-2.5-1.122-2.5-2.5V7h2v5.5c0,.276,.224,.5,.5,.5h.5V7h2v6h.5c.276,0,.5-.224,.5-.5V7h2v5.5c0,1.378-1.122,2.5-2.5,2.5h-.5v8.82c.652,.11,1.317,.18,2,.18,1.405,0,2.747-.254,4-.697v-4.509c-1.529-1.861-2.037-3.756-1.998-5.462,.121-3.077,1.666-5.25,2.606-6.102,.535-.497,1.388-.122,1.392,.507v14.645c3.583-2.076,6-5.942,6-10.381C24,5.373,18.627,0,12,0Z" />
    </svg>
  );
}

export function CompassIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...base(props)}>
      <path d="M6,24H8.13a2.02,2.02,0,0,0,1.941-1.532,2,2,0,0,1,3.858,0A2.02,2.02,0,0,0,15.87,24H18a3,3,0,0,0,3-3V17H17a1,1,0,0,1,0-2h4V5a5.006,5.006,0,0,0-5-5h-.13a2.02,2.02,0,0,0-1.941,1.532,2,2,0,0,1-3.858,0A2.02,2.02,0,0,0,8.13,0H8A5.006,5.006,0,0,0,3,5V15H7a1,1,0,0,1,0,2H3v4A3,3,0,0,0,6,24Zm5-9h2a1,1,0,0,1,0,2H11a1,1,0,0,1,0-2Z" />
    </svg>
  );
}

export function CalendarIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...base(props)}>
      <path d="M22.207,6.07c-.289-1.155-1.212-2.036-2.354-2.245-.166-.03-.337-.051-.505-.08v-1.022c0-.829-.671-1.5-1.5-1.5s-1.5,.671-1.5,1.5v.622c-2.872-.277-5.825-.277-8.697,0v-.622c0-.829-.671-1.5-1.5-1.5s-1.5,.671-1.5,1.5v1.021c-.167,.028-.339,.049-.505,.08-1.141,.208-2.065,1.089-2.354,2.244-.125,.502-.236,1.018-.331,1.545H22.539c-.096-.527-.206-1.043-.331-1.544Z" />
      <path d="M22.826,9.615H1.174c-.368,3.418-.163,7.099,.619,10.223,.289,1.155,1.213,2.036,2.354,2.244,2.532,.462,5.193,.694,7.854,.694s5.321-.231,7.854-.694c1.141-.208,2.065-1.089,2.354-2.244,.781-3.124,.987-6.804,.619-10.223ZM7.691,17.959c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Zm0-3.734c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Zm4.314,3.726c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Zm0-3.734c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Zm4.306,3.734c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Zm0-3.734c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Z" />
    </svg>
  );
}
